import { List, P, Strong } from '@ahmdigital/ui';
import React from 'react';

import { ambulanceIntro, dependantsExcess } from './shared';

export default {
  intro: {
    description: (
      <>
        <P>
          For those who like to stay savvy at tax time, by holding this hospital cover, you may be exempt from paying
          the Medicare Levy Surcharge~. And get peace of mind with Medically Necessary Ambulance cover^.
        </P>
        <Strong>Features</Strong>
        <List variant={['inside', 'withBottomMargin']}>
          <li>{dependantsExcess}</li>
          <li>{ambulanceIntro.feature}</li>
        </List>
      </>
    ),
    disclaimer: (
      <>
        <P>
          ~If you earn over $97K or $194K as a single parent, couple or family, you could save on tax with hospital
          cover. For single parents, couples and families, the income thresholds increase by $1,500 for each MLS
          dependant child after the first. ‘Income’ and ‘dependant’ have specific meanings for MLS purposes. Find out
          more at the ATO website.
        </P>
        {ambulanceIntro.featureDisclaimer}
      </>
    ),
  },
};
